import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import issueTracker from "./modules/issueTracker";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

Vue.use(Vuex);

export function defaultCurrentUser()
{
    return {
        id: 0,
        username: '',
        mail: '',
        group: 0,
        loyalty_points: 0,
        steam_id: '',
        twitch_id: '',
        twitch_loyalty_streamer: 0,
        mail_verified: 0,
        mail_verify_hash: '',
        last_activity: '',
        two_factor_secret: null,
        banned: 0,
    };
}

const state: RootState = {
    layoutData: {
        user: defaultCurrentUser(),
        avatar: '',
        avatars: {},
        usernames: {},
    },
    loader: {
        active: false,
        text: '',
    },
    hideApp: false,
    topMessages: [],
    flashMessages: [],
    layoutDataLoaded: false,
    pageLoading: false,
    loggedIn: false,
    errors: [],
    error: null,
};

let store: Store<RootState> = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    actions,
    getters,
    mutations,
    modules: {
        issueTracker,
    },
});

export default store;
